// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "HomeView" + "." + "96b410a3" + ".js";
};